/* UNIT 4 STUDIOS — Theme JS */

(function() {
  'use strict';

  /* ---- Mobile Menu ---- */
  const menuBtn = document.getElementById('mobile-menu-btn');
  const menuClose = document.getElementById('mobile-menu-close');
  const menu = document.getElementById('mobile-menu');

  function openMenu() {
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    menuClose && menuClose.focus();
  }

  function closeMenu() {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    menuBtn && menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    menuBtn && menuBtn.focus();
  }

  menuBtn && menuBtn.addEventListener('click', openMenu);
  menuClose && menuClose.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && menu && menu.classList.contains('is-open')) {
      closeMenu();
    }
  });

  /* ---- Product Gallery ---- */
  const thumbs = document.querySelectorAll('.product-media-gallery__thumb');
  const mainImg = document.querySelector('.product-media-gallery__main img');

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      const src = this.getAttribute('data-src');
      const srcset = this.getAttribute('data-srcset');
      if (mainImg && src) {
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
      }
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });

  /* ---- Variant Selector ---- */
  const variantBtns = document.querySelectorAll('.variant-selector__option');
  const variantInput = document.querySelector('input[name="id"]');
  const addToCartBtn = document.querySelector('.btn-add-to-cart');
  const priceEl = document.querySelector('.product-info__price');
  const availabilityEl = document.querySelector('.product-info__availability');

  variantBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (this.classList.contains('is-unavailable')) return;
      variantBtns.forEach(function(b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');

      const variantId = this.getAttribute('data-variant-id');
      const price = this.getAttribute('data-price');
      const comparePrice = this.getAttribute('data-compare-price');
      const available = this.getAttribute('data-available') === 'true';

      if (variantInput) variantInput.value = variantId;

      if (priceEl && price) {
        if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
          priceEl.innerHTML = '<span class="product-info__price--sale">' + price + '</span><span class="product-info__price--compare">' + comparePrice + '</span>';
        } else {
          priceEl.textContent = price;
        }
      }

      if (addToCartBtn) {
        if (available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'ADD TO BAG';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'SOLD OUT';
        }
      }

      if (availabilityEl) {
        if (available) {
          availabilityEl.textContent = 'IN STOCK';
          availabilityEl.classList.remove('product-info__availability--sold');
        } else {
          availabilityEl.textContent = 'SOLD OUT';
          availabilityEl.classList.add('product-info__availability--sold');
        }
      }
    });
  });

  /* ---- Add to Cart (AJAX) ---- */
  const addToCartForm = document.querySelector('.product-form form');
  if (addToCartForm && addToCartBtn) {
    addToCartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(this);
      addToCartBtn.textContent = 'ADDING...';
      addToCartBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(res) { return res.json(); })
      .then(function(item) {
        addToCartBtn.textContent = 'ADDED —';
        updateCartCount();
        setTimeout(function() {
          addToCartBtn.textContent = 'ADD TO BAG';
          addToCartBtn.disabled = false;
        }, 1800);
      })
      .catch(function() {
        addToCartBtn.textContent = 'ERROR — TRY AGAIN';
        addToCartBtn.disabled = false;
      });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      const count = cart.item_count;
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent = count;
      });
      // Update bottom nav bag count
      const bagLinks = document.querySelectorAll('.mobile-bottom-nav__item');
      bagLinks.forEach(function(link) {
        if (link.textContent.includes('BAG')) {
          link.querySelector('span').textContent = 'BAG(' + count + ')';
        }
      });
      // Update header bag
      const cartLinks = document.querySelectorAll('a[href="/cart"]');
      cartLinks.forEach(function(link) {
        if (link.textContent.includes('BAG')) {
          link.textContent = 'BAG(' + count + ')';
        }
      });
    });
  }

  /* ---- Cart qty buttons ---- */
  document.querySelectorAll('.cart-qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const input = this.parentElement.querySelector('.cart-qty-input');
      const line = this.closest('[data-line]') ? this.closest('[data-line]').getAttribute('data-line') : null;
      if (!input || !line) return;

      let qty = parseInt(input.value) || 1;
      if (this.getAttribute('data-action') === 'minus') qty = Math.max(0, qty - 1);
      else qty = qty + 1;

      input.value = qty;
      updateCartLineQty(line, qty);
    });
  });

  function updateCartLineQty(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function(res) { return res.json(); })
    .then(function() { window.location.reload(); });
  }

  /* ---- Product Accordion ---- */
  document.querySelectorAll('.product-accordion__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const item = this.closest('.product-accordion__item');
      const isOpen = item.classList.contains('is-open');
      // close all
      document.querySelectorAll('.product-accordion__item').forEach(function(i) {
        i.classList.remove('is-open');
        i.querySelector('.product-accordion__trigger').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---- Dropdown toggles (mobile-like) ---- */
  document.querySelectorAll('.header-nav__dropdown-toggle').forEach(function(btn) {
    btn.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const menu = this.nextElementSibling;
        const isOpen = menu.style.display === 'block';
        menu.style.display = isOpen ? '' : 'block';
        this.setAttribute('aria-expanded', String(!isOpen));
      }
    });
  });

})();
